import request from '@/utils/request'

// v80a1060List
export function v80a1060List(param) {
  let data = param
  return request({
    url: `/inspection/v80a1060/v80a1060List`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}
